BaseModel = require './base_model.coffee'

class global.RDStationCRMSetting extends BaseModel
  @ATTRIBUTES = {
    id: {}
    metadata: {}
    stage_id: {},
    triggers: {
      default: {
        on_created: false,
        status: ['connected'],
        stages: []
      },
      type: Object
    }
    properties_matching: { default: [], type: Object }
    stages_matching: { default: [], type: Object }
  }



// WEBPACK FOOTER //
// ./src/models/rd_station_crm_setting.coffee